import { useContext } from 'react';

import { QBankStructureCreationModalContext } from './qbank-structure-modal-creation-provider';

function useQBankStructureCreationModal() {
  const context = useContext(QBankStructureCreationModalContext);

  if (!context) {
    throw new Error(
      'useQBankStructureCreationModal must be used within a QBankStructureCreationModalActionProvider',
    );
  }

  return context;
}

export { useQBankStructureCreationModal };
